import { SearchFormType } from '../../search-page/search-page-type.enum';
import { SeSideComponentType } from '../se-side-components/se-side-components-models';

// #region Interfaces

export interface ISeSideNavFeatureComponentState {
    title: string;
    description: string;
    icon: string | null;
    active: boolean
}

export interface ISeSideNavDetailsComponentState extends ISeSideNavFeatureComponentState {
    searchForm: SearchFormType | null;
    idColumnName: string;
}

// #endregion

// #region Types

export type SeSideNavComponentState = {
    [SeSideComponentType.patientHistory]: ISeSideNavFeatureComponentState,
    [SeSideComponentType.reportPreview]: ISeSideNavFeatureComponentState,
    [SeSideComponentType.keyImagesPreview]: ISeSideNavFeatureComponentState,
    [SeSideComponentType.reporting]: ISeSideNavFeatureComponentState,
    [SeSideComponentType.details]: ISeSideNavDetailsComponentState
}

// #endregion

// #region States

export const seSideNavComponentInitialState: SeSideNavComponentState = {
    [SeSideComponentType.patientHistory]: {
        title: 'ClinicalHistory',
        description: '',
        icon: 'medical_information',
        active: false,
    },
    [SeSideComponentType.reportPreview]: {
        title: 'ReportPreview',
        description: '',
        icon: 'edit_note',
        active: false,
    },
    [SeSideComponentType.keyImagesPreview]: {
        title: 'KeyImages',
        description: '',
        icon: 'photo_album',
        active: false,
    },
    [SeSideComponentType.reporting]: {
        title: 'Reporting',
        description: '',
        icon: 'description',
        active: false,
    },
    [SeSideComponentType.details]: {
        title: 'Details',
        description: '',
        icon: 'list_alt',
        active: false,
        searchForm: null,
        idColumnName: ''
    }
    /* ... Altri componenti esterni gestiti dall'ecg */
};

// #endregion
